import { Icon } from '@iconify/react';
import instagramFill from '@iconify/icons-ant-design/instagram-filled';
import facebookFill from '@iconify/icons-eva/facebook-fill';
import linkedinFill from '@iconify/icons-eva/linkedin-fill';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
// material
import { experimentalStyled as styled } from '@mui/material/styles';
import { Grid, Link, Divider, Container, Typography, IconButton, Stack } from '@mui/material';
// routes
// import { PATH_PAGE } from '../../routes/paths';

// ----------------------------------------------------------------------

const SOCIALS = [
  { name: 'FaceBook', icon: facebookFill, href: 'https://www.facebook.com/ResiView/', target: '_blank' },
  { name: 'Instagram', icon: instagramFill, href: 'https://www.instagram.com/resiview_app/', target: '_blank' },
  // { name: 'Google', icon: googleFill, href:  },
  { name: 'Linkedin', icon: linkedinFill, href: 'https://www.linkedin.com/company/resiview/', target: '_blank' }
  // { name: 'Twitter', icon: twitterFill, href: 'https://www.linkedin.com/company/resiview/' },
];

const LINKS = [
  {
    headline: 'ResiView',
    children: [
      { name: 'About us', href: '/#about' },
      { name: 'FAQs', href: '/#faqs' },
      { name: 'Blog', href: '/blog/posts' },
      { name: 'News', href: '/news/posts' }
      // { name: 'Team', href: PATH_PAGE.team }
    ]
  },
  {
    headline: 'Legal',
    children: [
      { name: 'Terms and Condition', href: '#' },
      { name: 'Privacy Policy', href: '#' }
    ]
  },
  {
    headline: 'Contact',
    children: [
      { name: 'support@resiview.com', href: 'mailto: support@resiview.com', target: '_blank' },
      { name: 'Lenexa, KS', href: 'https://maps.app.goo.gl/x8R2jS6LrkdH8kvdA', target: '_blank' }
    ]
  }
];

const RootStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.default
}));

// ----------------------------------------------------------------------

export default function MainFooter() {
  return (
    <RootStyle>
      <Divider />
      <Container maxWidth="lg" sx={{ pt: 10 }}>
        <Grid
          container
          justifyContent={{ xs: 'center', md: 'space-between' }}
          sx={{ textAlign: { xs: 'center', md: 'left' } }}
        >
          <Grid item xs={12} sx={{ mb: 3 }}>
            <ScrollLink to="move_top" spy smooth>
              <img alt="Logo" src="/static/brand/Logo-04.png" style={{ width: '95px' }} />
            </ScrollLink>
          </Grid>
          <Grid item xs={8} md={3}>
            <Typography variant="body2" sx={{ pr: { md: 5 } }}>
              ResiView is an all encompassing application to track the current state of a home’s health. We are excited
              to help simplify your home tracking and maintenance.
            </Typography>

            <Stack
              spacing={1.5}
              direction="row"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              sx={{ mt: 5, mb: { xs: 5, md: 0 } }}
            >
              {SOCIALS.map((social) => (
                <IconButton
                  key={social.name}
                  color="primary"
                  sx={{ p: 1 }}
                  onClick={() => {
                    window.open(social.href, social.target);
                  }}
                >
                  <Icon icon={social.icon} width={16} height={16} />
                </IconButton>
              ))}
            </Stack>
          </Grid>

          <Grid item xs={12} md={7}>
            <Stack spacing={5} direction={{ xs: 'column', md: 'row' }} justifyContent="space-between">
              {LINKS.map((list) => {
                const { headline, children } = list;
                return (
                  <Stack key={headline} spacing={2}>
                    <Typography component="p" variant="overline">
                      {headline}
                    </Typography>
                    {children.map((link) => (
                      <Link
                        to={link.href}
                        key={link.name}
                        target={link.target}
                        color="inherit"
                        variant="body2"
                        component={RouterLink}
                        sx={{ display: 'block' }}
                      >
                        {link.name}
                      </Link>
                    ))}
                  </Stack>
                );
              })}
            </Stack>
          </Grid>
        </Grid>

        <Typography
          component="p"
          variant="body2"
          sx={{
            mt: 10,
            pb: 5,
            fontSize: 13,
            textAlign: { xs: 'center', md: 'left' }
          }}
        >
          © 2024. All rights reserved
        </Typography>
      </Container>
    </RootStyle>
  );
}
